import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ContractSearchFilter, ContractSearchFilters, CustomerSearchFilter, CustomerSearchFilters, InvoiceSearchFilter, 
  InvoiceSearchFilters, ManagerSearchFilters, ManagerUserSearchFilters, MeteringPointFilter, MeteringPointFilters, ServiceAgreementSearchFilter, UserCustomerSearchFilters, UserSearchFilter } from '@model';
import { MeteringType } from '@enums';

// This class is used by components that need to access the values of the metering point search filter
// Read more at https://angularfirebase.com/lessons/sharing-data-between-angular-components-four-methods/
@Injectable()
export class SearchFilterDataService {

    private searchFilter = new BehaviorSubject({
      coldMeteringPointFilter: {
        searchPhrase: '',
        searchName: true,
        searchClientName: true,
        searchAddress: true,
        searchGroupName: true,
        searchId: true,
        meteringType: MeteringType.Cold
      } as MeteringPointFilter,
      hotMeteringPointFilter: {
        searchPhrase: '',
        searchName: true,
        searchClientName: true,
        searchAddress: true,
        searchGroupName: true,
        searchId: true,
        meteringType: MeteringType.Hot
      } as MeteringPointFilter
    } as MeteringPointFilters);
    currentSearchFilter = this.searchFilter.asObservable();

    private invoiceSearchFilter = new BehaviorSubject({
      coldInvoiceSearchFilter: {
        searchPhrase: '',
        searchMeteringPointId: true,
        searchAddress: true,
        searchMeteringPoint: true,
        searchInvoiceId: true,
        meteringType: MeteringType.Cold
      } as InvoiceSearchFilter,
      hotInvoiceSearchFilter: {
        searchPhrase: '',
        searchMeteringPointId: true,
        searchAddress: true,
        searchMeteringPoint: true,
        searchInvoiceId: true,
        meteringType: MeteringType.Hot
      } as InvoiceSearchFilter
    } as InvoiceSearchFilters);
    currentInvoiceSearchFilter = this.invoiceSearchFilter.asObservable();

    private contractSearchFilter = new BehaviorSubject({
      coldContractSearchFilter: {
        searchPhrase: '',
        searchMeteringPointId: true,
        searchAddress: true,
        searchMeteringPoint: true,
        searchContractId: true,
        searchCustomerId: true,
        searchCustomer: true,
        meteringType: MeteringType.Cold
      } as ContractSearchFilter,
      hotContractSearchFilter: {
        searchPhrase: '',
      searchMeteringPointId: true,
      searchAddress: true,
      searchMeteringPoint: true,
      searchContractId: true,
      searchCustomerId: true,
      searchCustomer: true,
        meteringType: MeteringType.Hot
      } as ContractSearchFilter
    } as ContractSearchFilters);
    currentContractSearchFilter = this.contractSearchFilter.asObservable();

    // Customers and Users for logged in User
    private customerSearchFilter = new BehaviorSubject({
      customerSearchFilter: {
        searchPhrase: ''
      } as CustomerSearchFilter,
      customerUserSearchFilter: {
        searchPhrase: ''
      } as UserSearchFilter
    } as CustomerSearchFilters);
    currentCustomerSearchFilter = this.customerSearchFilter.asObservable();

    // Customers for selected User
    private userCustomerSearchFilter = new BehaviorSubject({
      customerSearchFilter: {
        searchPhrase: ''
      } as CustomerSearchFilter
    } as UserCustomerSearchFilters);
    currentUserCustomerSearchFilter = this.userCustomerSearchFilter.asObservable();

    // Customers and Users on ManagerCompany
    private managerSearchFilter = new BehaviorSubject({
      customerSearchFilter: {
        searchPhrase: ''
      } as CustomerSearchFilter,
      customerUserSearchFilter: {
        searchPhrase: ''
      } as UserSearchFilter
    } as ManagerSearchFilters);
    currentManagerSearchFilter = this.managerSearchFilter.asObservable();

    // Customers for selected ManagerUser
    private managerUserSearchFilter = new BehaviorSubject({
      customerSearchFilter: {
        searchPhrase: ''
      } as CustomerSearchFilter
    } as ManagerUserSearchFilters);
    currentManagerUserSearchFilter = this.managerUserSearchFilter.asObservable();

    // ServiceAgreements
    private serviceAgreementSearchFilter = new BehaviorSubject({
      searchPhrase: '', 
      searchAgreementId: true,
      searchService: true,
      searchMeteringPointId: true,
      searchMeteringPoint: true,
      searchCustomerId: true,
      searchCustomer: true
    } as ServiceAgreementSearchFilter);
    currentServiceAgreementSearchFilter = this.serviceAgreementSearchFilter.asObservable();

    constructor() { }

    pushSearchFilter(searchFilter: MeteringPointFilters) {
        this.searchFilter.next(searchFilter);
    }

    pushInvoiceSearchFilter(invoiceSearchFilter: InvoiceSearchFilters) {
        this.invoiceSearchFilter.next(invoiceSearchFilter);
    }

    pushContractSearchFilter(contractSearchFilter: ContractSearchFilters) {
      this.contractSearchFilter.next(contractSearchFilter);
    }

    pushCustomerSearchFilter(customerSearchFilter: CustomerSearchFilters) {
      this.customerSearchFilter.next(customerSearchFilter);
    }

    pushManagerSearchFilter(managerSearchFilter: ManagerSearchFilters) {
      this.managerSearchFilter.next(managerSearchFilter);
    }

    pushManagerUserSearchFilter(managerUserSearchFilter: ManagerUserSearchFilters) {
      this.managerUserSearchFilter.next(managerUserSearchFilter);
    }

    pushUserCustomerSearchFilter(userCustomerSearchFilter: UserCustomerSearchFilters) {
      this.userCustomerSearchFilter.next(userCustomerSearchFilter);
    }

    pushServiceAgreementSearchFilter(serviceAgreementSearchFilter: ServiceAgreementSearchFilter) {
      this.serviceAgreementSearchFilter.next(serviceAgreementSearchFilter);
  }
}